import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';

const PITCH_DECK_URL = "https://docs.google.com/presentation/d/e/2PACX-1vQFnt58z8FwscXN3Ty1MANFOykAcRMQtACQaRoXymfOvwdVGQfpD6GbfHvMlK34dwrYcQP7X5i6f2CD/pub?start=false&loop=false&delayms=3000";
const PITCH_DECK_EMBED = "https://docs.google.com/presentation/d/e/2PACX-1vQFnt58z8FwscXN3Ty1MANFOykAcRMQtACQaRoXymfOvwdVGQfpD6GbfHvMlK34dwrYcQP7X5i6f2CD/pubembed?start=false&loop=false&delayms=3000";

export const PitchPage: React.FC = () => {
  const menuItems = [
    { label: 'Features', href: '/#features' },
    { label: 'Blog', href: '/blog' },
    { label: 'Press', href: '/press' },
    { label: 'Pitch', href: '/pitch' },
    { label: 'Enterprise API', href: '/enterprise-api' }
  ];

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Helmet>
        <title>Cura Pitch Deck – Revolutionizing Senior Healthcare</title>
        <meta name="description" content="Explore Cura's vision and strategy for transforming senior healthcare with AI. View our pitch deck and learn about our mission ✓" />
        <link rel="canonical" href="https://mycura.org/pitch" />
        <meta property="og:title" content="Cura Pitch Deck – Revolutionizing Senior Healthcare" />
        <meta property="og:description" content="Explore Cura's vision and strategy for transforming senior healthcare with AI. View our pitch deck and learn about our mission." />
        <meta property="og:url" content="https://mycura.org/pitch" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Cura Pitch Deck – Revolutionizing Senior Healthcare" />
        <meta name="twitter:description" content="Explore Cura's vision and strategy for transforming senior healthcare with AI. View our pitch deck and learn about our mission." />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Cura Pitch",
            "url": "https://mycura.org/pitch",
            "isPartOf": { "@type": "WebSite", "name": "Cura", "url": "https://mycura.org" }
          })}
        </script>
      </Helmet>
      <Navigation
        menuItems={menuItems}
        scrollToSection={scrollToSection}
        scrollToTop={scrollToTop}
      />

      {/* Header Section with existing gradient */}
      <div className="relative overflow-hidden gradient-bg pt-32">
        <div className="container mx-auto px-4 py-3 text-center flex flex-col justify-center h-full min-h-[60px]">
          <div className="mb-4 mt-2">
            {/* Logo and Title */}
            <div className="mb-2">
              <div className="flex justify-center mb-2">
                <img
                  src="/images/Long Logo.png"
                  alt="Cura"
                  className="h-10 w-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Body Section with white background */}
      <div className="flex flex-col items-center py-6 sm:py-10 md:py-16 px-2 bg-white w-full flex-1">
        <div className="w-full flex justify-center">
          <div className="w-full max-w-[95vw] sm:max-w-2xl md:max-w-3xl lg:max-w-5xl xl:max-w-7xl aspect-video">
            <iframe
              src={PITCH_DECK_EMBED}
              frameBorder="0"
              allowFullScreen
              title="Cura Pitch Deck"
              className="rounded-lg shadow-lg w-full h-full min-h-[220px] sm:min-h-[350px] md:min-h-[420px] lg:min-h-[520px] xl:min-h-[620px]"
              style={{ minHeight: 220 }}
            ></iframe>
          </div>
        </div>
        <a
          href={PITCH_DECK_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center px-6 py-3 mt-6 bg-blue-600 text-white rounded-full shadow hover:bg-blue-700 transition-colors text-lg font-semibold"
        >
          Direct Link
          <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M17 7l-10 10M17 7h-6m6 0v6" />
          </svg>
        </a>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};
